import { ConfigType } from "../utils/requestAPI";

type CreateUpdateRegistrationPayload = {
  regType: string;
  company: string;
  logo: string;
};

const tradeRegistrationApis = {
  getAllTradeRegistration: (): ConfigType => {
    return {
      method: "get",
      url: `/trade-registration-types`,
    };
  },
  addNewTradeRegistration: (
    data: CreateUpdateRegistrationPayload
  ): ConfigType => {
    return {
      method: "post",
      url: "/trade-registration-types",
      data,
    };
  },
  deleteTradeRegistration: (id: string): ConfigType => {
    return {
      method: "delete",
      url: `/trade-registration-types/${id}`,
    };
  },
  updateTradeRegistration: (
    id: string,
    data: CreateUpdateRegistrationPayload
  ): ConfigType => {
    const finalData = { ...data, registrationTypeId: id };
    return {
      method: "post",
      url: `/trade-registration-types`,
      data: finalData,
    };
  },
};

export default tradeRegistrationApis;
